module.exports = __webpack_public_path__ + "static/img/lang.dcf656d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lang.png
// module id = 2i9y
// module chunks = 0